<template>
  <v-chip small :color="tone.color" :text-color="tone.text" class="chip-tight">{{ status }}</v-chip>
</template>

<script>
export default {
  props: ['status'],
  data() {
    return {
      
    };
  },
  computed: {
    tone: function () {
      var bad = ['Collections', 'Hold', 'Review Hold', 'Behind', 'Returned R01', 'ACH returns', 'Below schedule'];
      var warn = ['Slow Pay', 'Scheduled', 'On Pace', 'Near Payoff', 'High exposure', 'Watch'];
      var good = ['Performing', 'Ahead', 'Ready for Payout', 'Paid', 'Settled', 'Strong'];
      if (bad.indexOf(this.status) > -1) return { color: 'red lighten-5', text: 'red darken-3' };
      if (warn.indexOf(this.status) > -1) return { color: 'amber lighten-5', text: 'amber darken-4' };
      if (good.indexOf(this.status) > -1) return { color: 'green lighten-5', text: 'green darken-3' };
      return { color: 'grey lighten-3', text: 'blue-grey darken-2' };
    }
  },
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
